import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

import {HiFire} from 'react-icons/hi'

import Header from '../Header'
import Sidebar from '../Sidebar'
import TrendingVideo from '../TrendingVideo'

import ModeContext from '../../context/ModeContext'

import {
  Flex,
  TrendingContainer,
  TrendingCard,
  TrendingIcon,
  TrendingTitle,
  TrendingVideos,
} from './styledComponents'

import {
  NoResults,
  NoRImg,
  NoR,
  NoRPara,
  RetryButton,
} from '../Home/styledComponents'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class Trending extends Component {
  state = {videosList: [], apiStatus: apiStatusConstants.initial}

  componentDidMount() {
    this.getTrendingVideos()
  }

  getTrendingVideos = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})

    const jwtToken = Cookies.get('jwt_token')
    const url = `https://apis.ccbp.in/videos/trending`
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(url, options)

    if (response.ok) {
      const data = await response.json()
      const updatedData = {
        total: data.total,
        videos: data.videos.map(each => ({
          id: each.id,
          publishedAt: each.published_at,
          thumbnailUrl: each.thumbnail_url,
          title: each.title,
          viewCount: each.view_count,
          channel: {
            name: each.channel.name,
            profileImageUrl: each.channel.profile_image_url,
          },
        })),
      }
      this.setState({
        videosList: updatedData.videos,
        apiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  onClickRetry = () => {
    this.getTrendingVideos()
  }

  renderLoader = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderFailure = () => (
    <ModeContext.Consumer>
      {value => {
        const {isDarkMode} = value
        const color = isDarkMode ? 'white' : 'black'
        const bg = isDarkMode ? '#0f0f0f' : '#f1f1f1'
        const src = isDarkMode
          ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
          : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'

        return (
          <NoResults bg={bg}>
            <NoRImg failure src={src} alt="failure view" />
            <NoR color={color}>Oops! Something Went Wrong</NoR>
            <NoRPara>
              We are having some trouble to complete your request.
              <br />
              Please try again.
            </NoRPara>
            <RetryButton onClick={this.onClickRetry}>Retry</RetryButton>
          </NoResults>
        )
      }}
    </ModeContext.Consumer>
  )

  renderSuccess = () => {
    const {videosList} = this.state

    return (
      <ModeContext.Consumer>
        {value => {
          const {isDarkMode} = value
          const containerBg = isDarkMode ? '#0f0f0f' : '#f1f1f1'
          const cardBg = isDarkMode ? '#181818' : '#ebebeb'
          const iconBg = isDarkMode ? '#0f0f0f' : '#e2e8f0;'
          const color = isDarkMode ? 'white' : 'black'

          return (
            <TrendingContainer containerBg={containerBg}>
              <TrendingCard cardBg={cardBg}>
                <TrendingIcon iconBg={iconBg}>
                  <HiFire />
                </TrendingIcon>
                <TrendingTitle color={color}>Trending</TrendingTitle>
              </TrendingCard>
              <TrendingVideos>
                {videosList.map(each => (
                  <TrendingVideo key={each.id} video={each} />
                ))}
              </TrendingVideos>
            </TrendingContainer>
          )
        }}
      </ModeContext.Consumer>
    )
  }

  renderTrending = () => {
    const {apiStatus} = this.state

    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderSuccess()
      case apiStatusConstants.failure:
        return this.renderFailure()
      case apiStatusConstants.inProgress:
        return this.renderLoader()
      default:
        return null
    }
  }

  render() {
    return (
      <>
        <Header />
        <Flex>
          <Sidebar />
          {this.renderTrending()}
        </Flex>
      </>
    )
  }
}

export default Trending
